<template>
  <div>
    <CatalogueLive code="consentement1" v-model="sasConsentement.consentement1" :live="liveSasConsentement(5902)" />
    <CatalogueLive code="consentement3" v-model="sasConsentement.consentement3" :live="liveSasConsentement(5904)" />
    <CatalogueLive code="consentement4" v-model="sasConsentement.consentement4" :live="liveSasConsentement(5905)" />
    <CatalogueLive code="consentement8" v-model="sasConsentement.consentement8" :live="liveSasConsentement(5909)" />
    <CatalogueLive code="consentement9" v-model="sasConsentement.consentement9" :live="liveSasConsentement(5910)" />
    <CatalogueLive code="consentement_lapersonnelle" v-model="sasConsentement.consentement16" :live="liveSasConsentement(5917)" />
  </div>
</template>

<script>
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"

export default {
  mixins: [CataloguesHelpers],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasConsentement() {
      return this.sas.sasConsentement
    }
  },
  methods: {
    liveSasConsentement(cle) {
      return { endpoint: "sas-consentements", cle: cle, fileId: this.sasConsentement.id }
    }
  }
}
</script>

<style></style>
